<app-error-summary [error]="scope.error"></app-error-summary>
<div #banner>
    <div class="banner" *ngIf="scope.updated">
        <h2 class="banner__text" [innerText]="scope.getText | transform:'PROFILE_UPDATED'"></h2>
    </div>
</div>
<div *ngIf="(scope.fieldConfig$ | async) as fields" [ngClass]="{'disabled--loading': scope.loading}">
    <dynamic-form (submit)="scope.submitForm($event)" [fields]="fields"></dynamic-form>
</div>